<template>
  <p-button
    as="link"
    :href="url"
    :target="open_in_new_window ? '_blank' : '_self'"
    variant="secondary"
    @click.native.prevent="ctaLinkButtonClicked"
  >
    <div class="flex items-center gap-2">
      <span>{{ label }} </span>
      <i class="fas fa-arrow-right"></i>
    </div>
  </p-button>
</template>
<script lang="ts" setup>
import { rbgContentPageLinkClickedV100 } from "kaleido-event-tracker";

export interface UrlObject {
  url: string;
  label: string;
  open_in_new_window: boolean;
  link_tracking_identifier?: string;
}

const props = defineProps<UrlObject>();

const ctaLinkButtonClicked = () => {
  if (props.link_tracking_identifier) {
    rbgContentPageLinkClickedV100({ identifier: props.link_tracking_identifier });
  }
  if (props.open_in_new_window) {
    window.open(props.url, "_blank");
  } else {
    window.location.href = props.url;
  }
};
</script>
